<template>
  <div class="sobre-ffjb-container">
    <!-- SEO: Título principal com palavra-chave -->
    <!-- Missão, Visão, Valores -->
    <section class="cards-section">
      <div class="card fade-in">
        <h2>Missão</h2>
        <p>Oferecer serviços de alta qualidade que tragam segurança, conforto e eficiência para os nossos clientes</p>
      </div>
      <div class="card fade-in">
        <h2>Visão</h2>
        <p>Ser referência no mercado nacional em eletricidade, climatização, automação e manutenção de equipamentos</p>
      </div>
      <div class="card fade-in">
        <h2>Valores</h2>
        <p>Ética, inovação, compromisso, sustentabilidade e valorização das pessoas.</p>
      </div>
    </section>

    <section class="ffjb">
      <h2>A *FFJB - Prestação de Serviços e Comércio*</h2>
      <p>
        Sediada no vibrante Bairro da Luz, Lobito, desde 13 de maio de 2020, transcende o conceito de uma simples
        empresa de serviços técnicos. Com um portfólio que abrange eletrônica, eletricidade civil e industrial,
        climatização, automação, manutenção de máquinas, elevadores, portas automáticas, eletromecânica e
        telecomunicações, a FFJB não apenas entrega soluções certificadas por normas internacionais (ISO, IEC, EN, ASME,
        ABNT, RoHS, CE, ASHRAE), mas também se posiciona como um agente transformador na vida de seus clientes,
        trabalhadores e no progresso de Angola. Nosso impacto é profundo, enraizado em valores de confiabilidade,
        inovação e compromisso com o desenvolvimento humano e econômico.
      </p>
    </section>
    <section class="ffjb">
      <h2>*Para os Clientes: Um Farol de Confiança e Transformação*</h2>
      <p>
        Para os clientes – sejam famílias, pequenos comerciantes ou grandes indústrias de Benguela – a FFJB é mais do
        que um prestador de serviços; é um parceiro que ilumina o caminho para a segurança, eficiência e modernidade. Ao
        instalar sistemas elétricos robustos, reparar equipamentos essenciais ou implementar portas automáticas que
        agilizam operações comerciais, como em lojas ou até no imaginário de um aeroporto regional, garantimos que os
        sonhos de nossos clientes ganhem vida. Um sistema de ar condicionado bem instalado em um escritório no Bairro da
        Luz não é apenas conforto térmico; é a criação de um ambiente onde ideias florescem e produtividade prospera.
        Uma câmara fria para um mercado local não é apenas tecnologia; é a preservação de alimentos que sustenta
        famílias e fortalece comunidades. Nossa política de pagamento transparente – com serviços simples pagos na
        conclusão e projetos complexos divididos em fases acessíveis – reflete nosso respeito pela realidade financeira
        de nossos clientes, construindo confiança duradoura. Cada projeto concluído, como a automação de uma linha de
        produção ou a manutenção de um elevador, é um passo para que nossos clientes vivam com mais segurança, conforto
        e esperança em um futuro melhor.

      </p>
    </section>
    <section class="ffjb">
      <h2>*Para os Trabalhadores: Um Espaço de Crescimento e Dignidade* </h2>
      <p>
        Na FFJB, nossos trabalhadores não são apenas funcionários; são artesãos do progresso, cuja expertise e dedicação
        moldam o futuro de Benguela. Cada técnico que repara um motor industrial, programa um CLP ou instala uma rede de
        telecomunicações carrega consigo a responsabilidade de transformar vidas. Oferecemos um ambiente onde o
        aprendizado contínuo é valorizado, capacitando nossos profissionais com treinamentos alinhados às normas
        internacionais, como IEC 61131-3 para automação ou EN 81 para elevadores. Este investimento no capital humano
        não apenas eleva a competência técnica, mas também reforça a autoestima e o senso de propósito. Nossos
        trabalhadores, muitos deles moradores locais do Lobito, encontram na FFJB uma oportunidade de sustentar suas
        famílias com dignidade, contribuindo diretamente para a economia local. Ao participarem de projetos inovadores,
        como sistemas IoT para indústrias ou portas automáticas de alta tecnologia, eles se tornam protagonistas de uma
        Angola moderna, onde o trabalho qualificado é sinônimo de orgulho e impacto social.
      </p>
    </section>
    <section class="ffjb">
      <h2>*Para o Desenvolvimento de Angola: Um Catalisador de Progresso*</h2>
      <p>A FFJB é um pilar no desenvolvimento de Angola, especialmente na província de Benguela, onde o crescimento
        econômico e a modernização caminham de mãos dadas com a sustentabilidade e a inclusão. Ao fornecer serviços que
        modernizam indústrias, como a automação de linhas de produção que reduzem custos e aumentam a competitividade,
        contribuímos para a criação de empregos indiretos e para o fortalecimento do tecido industrial angolano. Nossas
        soluções de climatização e refrigeração, como câmaras frias que atendem mercados locais, apoiam a segurança
        alimentar e o comércio, pilares essenciais para a estabilidade econômica. Além disso, ao implementar sistemas de
        telecomunicações e redes estruturadas, conectamos comunidades e empresas ao mundo digital, promovendo a inclusão
        na era da Indústria 4.0. Cada projeto da FFJB, seja a instalação de um elevador que torna um edifício acessível
        ou a manutenção de máquinas que mantêm uma fábrica em operação, é um tijolo na construção de uma Angola mais
        próspera e autossuficiente. Nosso compromisso com normas internacionais assegura que esses avanços sejam
        sustentáveis, respeitando o meio ambiente e alinhando-se às metas de desenvolvimento nacional.
      </p>
    </section>
    <section class="ffjb">
      <h2>*Uma Visão de Futuro*</h2>
      <p>
        O impacto da FFJB vai além dos serviços prestados; ele ressoa nas histórias de vida transformadas. Para o
        cliente que vê seu negócio crescer com uma instalação elétrica confiável, para o trabalhador que encontra
        propósito em cada circuito reparado, e para o país que avança com cada inovação implementada, a FFJB é um
        símbolo de esperança e progresso. Estamos construindo não apenas sistemas técnicos, mas um legado de confiança,
        capacitação e desenvolvimento que ecoará por gerações em Benguela e além. Convidamos você a fazer parte dessa
        jornada entre em contato e descubra como podemos transformar sua realidade!
      </p>
    </section>


    <section class="team-section scale-in">
      <h2>Conheça Nossa Equipa</h2>
      <div class="team-grid">
        <div class="team-member" v-for="(membro, index) in equipa" :key="index">
          <div class="image-container">
            <img :src="membro.foto" :alt="membro.nome" />
          </div>
          <h3>{{ membro.nome }}</h3>
          <p>{{ membro.cargo }}</p>
        </div>
      </div>
    </section>

    <!-- Chamada para Ação -->
    <section class="cta scale-in">
      <h3>Transforme seu ambiente com tecnologia e eficiência</h3>
      <p>Fale com a equipe da FFJB e solicite um orçamento personalizado agora mesmo.</p>
      <a href="/contacto" class="cta-button">Entrar em Contato</a>
    </section>
  </div>
</template>

<script>
export default {
  name: "SobreFFJB",
  data() {
    return {
      equipa: [
        {
          nome: "Frederico Batalha",
          cargo: "CEO",
          foto: "/images/fre.jpg"
        },
        {
          nome: "Miguel Celestina",
          cargo: "Eng. Electrónico e Telecomunicações",
          foto: "/images/miguel.jpg"
        },
        {
          nome: "Paula Kutenga",
          cargo: "Gestora Administrativa",
          foto: "/images/paula.jpg"
        },
        {
          nome: "Fernanda Pacheco",
          cargo: "Gestora Financeira",
          foto: "/images/fernandap.jpg"
        },
        {
          nome: "Mateus Gaspar",
          cargo: "Técnico em Climatização",
          foto: "/images/mateus.jpg"
        },
        {
          nome: "Fernanda da Silva",
          cargo: "Gestora Comercial",
          foto: "/images/fernandas.jpg"
        },
        {
          nome: "Augusto Colar",
          cargo: "Logistico e Gestor Técnico",
          foto: "/images/augusto.jpg"
        }
      ]
    };
  }
};
</script>

<style scoped>
/* Animações */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes scaleIn {
  from {
    transform: scale(0.95);
    opacity: 0;
  }

  to {
    transform: scale(1);
    opacity: 1;
  }
}

.fade-in {
  animation: fadeIn 0.8s ease forwards;
}

.scale-in {
  animation: scaleIn 0.8s ease forwards;
}

/* Container */
.sobre-ffjb-container {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  background: linear-gradient(135deg, #f5f9ff, #e6f0fa);
  padding: 60px 20px;
  color: #2c3e50;
  max-width: 1200px;
  margin: 0 auto;
}

/* Introdução */
.intro {
  text-align: center;
  margin-bottom: 60px;
}

.ffjb {
  text-align: center;
  margin-bottom: 60px;
}

.intro h1 {
  font-size: 38px;
  color: #0056b3;
  margin-bottom: 20px;
}

.ffjb p {
  text-align: justify;
  font-size: 18px;
  line-height: 1.7;
  max-width: 800px;
  margin: 10px auto;
}

.intro p {
  font-size: 18px;
  line-height: 1.7;
  max-width: 800px;
  margin: 10px auto;
}

/* Cartões Missão, Visão, Valores */
.cards-section {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 30px;
  margin-bottom: 60px;
}

.card {
  background: #0a01ff;
  border-radius: 16px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.1);
  padding: 30px;
  width: 320px;
  text-align: center;
  transition: transform 0.4s ease, box-shadow 0.3s;
}

.card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
}

.card h2 {
  color: #ffffff;
  font-size: 24px;
  margin-bottom: 10px;
}

.card p {
  font-size: 16px;
  color: #ffffff;
}

.team-section {
  padding: 40px 20px;
  text-align: center;
  background-color: #f9f9f9;
}

.team-section h2 {
  font-size: 2rem;
  margin-bottom: 30px;
  color: #333;
}

.team-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  max-width: 1000px;
  margin: 0 auto;
  justify-items: center;
}

.team-member {
  width: 100%;
  max-width: 180px; /* <-- Reduziu de 250px */
  background-color: #fff;
  border-radius: 10px;
  padding: 15px; /* <-- Reduziu */
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease;
}

.image-container {
  width: 100%;
  aspect-ratio: 1 / 1;
  overflow: hidden;
  border-radius: 50%;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f2f2f2;
}

.image-container img {
  width: 100%;
  height: 200px;
  object-fit: contain; /* 👈 Muda de 'cover' para 'contain' */
  object-position: top; /* 👈 Alinha a cabeça para cima */
  display: block;
}

.team-member h3 {
  font-size: 1rem; /* <-- Reduzido */
  margin: 8px 0 4px;
  color: #222;
}

.team-member p {
  font-size: 0.85rem; /* <-- Reduzido */
  color: #666;
}

/* Chamada para Ação */
.cta {
  background-color: #0056b3;
  color: white;
  text-align: center;
  padding: 50px 30px;
  border-radius: 20px;
}

.cta h3 {
  font-size: 26px;
  margin-bottom: 12px;
}

.cta p {
  font-size: 18px;
  margin-bottom: 20px;
}

.cta-button {
  display: inline-block;
  background-color: white;
  color: #0056b3;
  padding: 14px 32px;
  font-weight: bold;
  border-radius: 10px;
  text-decoration: none;
  transition: background-color 0.3s ease, transform 0.3s ease;
}

.cta-button:hover {
  background-color: #000000;
  transform: scale(1.05);
}

/* Responsividade */
@media (max-width: 768px) {
  .cards-section {
    flex-direction: column;
    align-items: center;
  }

  .intro h1 {
    font-size: 30px;
  }

  .team-grid {
    gap: 20px;
  }

  .cta {
    padding: 30px 20px;
  }

  .cta h3 {
    font-size: 22px;
  }
}

@media (max-width: 480px) {

  .card,
  .team-member {
    width: 90%;
  }

  .intro p,
  .cta p {
    font-size: 16px;
  }

  .cta-button {
    padding: 12px 24px;
    font-size: 16px;
  }
}
</style>
